import Cookies from 'js-cookie'

const TokenKey = 'loginTokenSeller'

export function getToken() {
  return Cookies.get('needTwoStepVerificationSeller') === 'true' ? '' : Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token,{
    expires: 7,       // 7天后过期
    // path: '/',         // 全站生效
    // secure: true,      // 仅HTTPS传输（生产环境建议开启）
    // sameSite: 'Lax'    // 防止CSRF攻击
  })
}

export function removeToken() {
  Cookies.remove('needTwoStepVerificationSeller')
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js